export class LoanLockDeskSettingsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSettings({ loanId }) {
    return this.#http.get(`/loan/${loanId}/lock-desk/settings`);
  }

  async getSettingsV2({ loanId }) {
    return this.#http.get(`/loan/${loanId}/lock-desk/settings/v2`);
  }
}
